import React, { Component } from "react";
import "../../css/toastView.css";
 
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
 
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";
import "../../components/new.css";
 
import "react-tabs/style/react-tabs.css";
import "../../css/events.css";
 
import "../../components/slick.css";
import "../../components/slick-theme.css";
 


const icon1 = "https://winpeforum.com/assets/elements/AchithaJacob.png";
const icon2 = "https://winpeforum.com/assets/elements/AnjaIiSosale.jpg";
const icon3 = "https://winpeforum.com/assets/elements/NruthyaMadappa.jpg";
const icon4 = "https://winpeforum.com/assets/elements/KanikaMayar.jpeg";
 
let duration = 400;

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

class WinPEEdge extends Component {
  // constructor() {
  //   super();
  //   this.state = {
  //     isShow: false,
  //     activeItem: {},
  //   };
  // }

  // togglePopUp = (item) => {
  //   this.setState({
  //     isShow: !this.state.isShow,
  //     activeItem: item || {},
  //   });
  // };
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };

 
    this.Speaker2 = [
      {
        imgUrl: icon1,
        desc: `<div>
        Achitha Jacob is the CEO and Founder at Proactive For Her. Achitha dropped out of Harvard Business School to build Proactive For Her. She has previously worked with Fortune 500 healthcare and management consulting, after graduating from IIT Bombay.


		</div>`,
        name: "Achitha Jacob",
        post: `<div>CEO & Founder<br/> Proactive For Her
        </div>`,
      },
      {
        imgUrl: icon2,
        desc: `<div>
        AnjaIi Sosale is a Partner at WaterBridge Ventures, an early stage, India focused, Seed to Series A fund, that invests between $250k and $2.5m first cheques into tech-startups. Anjali focuses on consumer tech and is based in Bangalore. Anjali has over 15 years of experience in various parts of the investment eco-system advising companies on their capital agenda. She started her career in investment banking, with EY in 2006 where she spent a decade across multiple geographies and deal advisory domains from due diligence to cross-border M&A and private equity. Initially (2009-14) fundraising for growth stage education, retail and consumer companies before the internet economy boom led her to focus (from 2015 onwards) on the burgeoning start-up eco-system driving consumer tech and e-commerce in India.<br/><Br/>

        She was instrumental in setting up the early stage, start-up focused practice in 2014 which she led until she left in 2017 to join Myntra (A Flipkart and Walmart Group Company and India's largest fashion e- commerce company). At Myntra, Anja Iiwas head of the Brand Accelerator Program, that sought out minority equity partnerships to jointly scale the next generation of D2C fashion and lifestyle brands in India.
        <br/><Br/>
        She took the program from idea and concept to scale, creating the first generation of D2C brands in India, diversifying the portfolio of 16 across lifestyle categories, introducing and expanding it into Flipkart. These brands collectively earned over $100m in annual revenues for the FK Group making them a valuable part of the ecosystem and generating incredible value to its founders with brands blitz scaling to Rs 100 crs brands within 2 years
        
		</div>`,
        name: "AnjaIi Sosale",
        post: `<div>Partner<br/> WaterBridge Ventures


        </div>`,
      },
      {
        imgUrl: icon4,
        desc: `<div>
        Kanika has 11 years of experience across venture capital and growth stage investing.  She joined Vertex in 2020 as part of the India investment team. At Vertex, Kanika has led investments into consumer, health, agri, B2B and other sectors where technology can play a pivotal role in scaling and achieving strong business economics. Prior to joining Vertex, Kanika was an Investment Officer with the International Finance Corporation (IFC) where she focused on investing in early-stage technology, telecom, renewable energy and infrastructure companies across India and South Asia. Before IFC, Kanika was with Goldman Sachs’s Investment Banking team covering transactions in natural resources in Europe.<br/><br/>

Kanika holds a Bachelor in Economics from the Lady Shri Ram College, Delhi University and an MBA from the Indian Institute of Management, Ahmedabad.

 
        

		</div>`,
        name: "Kanika Mayar",
        post: `<div>Partner<br/>Vertex Ventures


        </div>`,
      },
      {
        imgUrl: icon3,
        desc: `<div>
        Nruthya Madappa is the Head of Growth and Capital Development at 3one4 Capital. In addition to supporting investments, topline and capital growth for the portfolio at the firm, Nruthya works closely with global institutional and strategic investors to drive the growth of our portfolio companies. Her team partners deeply with the latter in planning and achieving financial and strategic objectives including capital raises, revenue acceleration, M&A, and exits. 
        <br/><Br/>
        Over her career in the US and India, Nruthya has led global teams across technology, finance, real estate, education and economic policy. Before 3one4 Capital, Nruthya founded and led The CoWrks Foundry (a business accelerator for early stage companies) as Managing Partner, investing in over 25 companies and establishing global partnerships with Yale and Columbia University. <br/><Br/>
        
        Prior to The CoWrks Foundry she drove the Revenue and Growth orgs at Cuemath and spearheaded the 15M Series B from Capital G and Sequoia Capital for the edtech giant. Throughout her career, Nruthya has designed and scaled products, and raised capital for high growth companies - strengths she brings to bear for the 3one4 portfolio. <br/><Br/>
        
        Nruthya holds BS and MS degrees in Electrical Engineering from Stanford University and an MBA from Harvard Business School.
        

		</div>`,
        name: "Nruthya Madappa",
        post: `<div>Director<br/> 3one4 Capital 


        </div>`,
      },
      
      
    ];
    
    
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };

  

  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
     
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;

    return (
      <ContentPage>
      <Meta
      title="SheShines with Winpe"
      image={"https://winpeforum.com/assets/elements/sheshineswebpage1.png"}
      description="Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions!"
      location={location}
    />
      <div className="section__content" style={defaultStyle}>
     <div className="toastshine_wrapper">
     
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left"> Back to Events</i>
              </Link>
            </div> 
   
            <div className="toastshine_section">
        <h1 className="ignite-ask-me-anything__heading">SheShines with Winpe </h1>
        
           
        <hr className="ignite-ask-me-anything__hr"></hr>
        <div className="top_text">
        <b>she</b>shines with Winpe are in-person networking sessions for women in the investing and entrepreneurship ecosystem.
<br/><br/>

The importance of building strong networks cannot be underscored too much. The number of women in investing and entrepreneurship continues to be small and the imperative for everyone to know each other, support each other and leverage each other is that much stronger.
<br/><br/>

Through these events, Winpe attempts to bring women together to meet old friends and make new ones.
<br/><br/>

<b>she</b>shines events include interactive, candid and close-range discussions with senior women leaders and women champions from various fields and of course, lots of networking.
<br/><br/>

<b>she</b>shines will be in Mumbai, Bangalore & Delhi/Gurgaon every quarter.
<br/><br/>

              </div>
              <br />

              <br />
             

    
      
   
  <div className="tab_section container" style={{textAlign: 'center'}}>
   
  <ul class="nav nav-tabs justify-content-center" role="tablist" style={{display: "inline-block"}}>
  <li class="nav-item">
		<a class="nav-link  " data-toggle="tab" href="#tabs-3" role="tab" style={{padding: "10px 5px"}}>
      <h4 style={{fontSize: '17px'}} className="ignite-ask-me-anything__heading"> &nbsp; Mumbai&nbsp;  </h4> </a>
	</li>
	<li class="nav-item">
		<a class="nav-link  " data-toggle="tab" href="#tabs-1" role="tab" style={{padding: "10px 5px"}}> <h4 style={{fontSize: '17px'}} className="ignite-ask-me-anything__heading"> &nbsp;  Delhi&nbsp;   </h4> </a>
	</li>
  <li class="nav-item">
		<a class="nav-link  active " data-toggle="tab" href="#tabs-2" role="tab" style={{padding: "10px 5px"}}> 
    <h4 style={{fontSize: '17px'}} className="ignite-ask-me-anything__heading"> &nbsp;  Bangalore&nbsp;   </h4> </a>
	</li>
	
 
</ul> 
<div class="tab-content">
	<div class="tab-pane" id="tabs-1" role="tabpanel"><br/><br/><br/>
  
  <div className="eventlist_listing eventlist_listing_new">
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>August 25, 2022 (5:00 PM - 8:00 PM IST)</h3>
                  <br/>
                            <strong>
                            <h5>Networking works </h5>

                            </strong>
                  
                  <h4> <i>Hotel Andaz, Aerocity - Delhi</i></h4>
                             
                  <br/> <br/>               

          <center>  
         <a href="/SheShines25Aug2022/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
     
                          <hr/><hr/>
              
                          </div>
                      </div>
                    </div>
       
            
  
              </div>        
                    
	</div>
  <div class="tab-pane active" id="tabs-2" role="tabpanel"><br/><br/><br/>
  
  <div className="eventlist_listing eventlist_listing_new">
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>January 19, 2023 (4:00 PM - 7:00 PM IST)</h3>
                  <br/>
                            <strong>
                            <h5>Journeys: Women & Leadership</h5>

                            </strong>
                  
                  <h4> <i>Jook Taproom, Indiranagar, Bangalore</i></h4>
                            <br/><br/>
                            <center>  
         <a href="/SheShines19Jan2023/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 

  
              
                          </div>
                      </div>
                    </div>
       
              <hr/><hr/>

  
              </div> 



  <div className="eventlist_listing eventlist_listing_new">
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">

                
                  <h3>June 30, 2022 (5:00 PM - 8:00 PM IST)</h3>
                  <br/>
                            <strong>
                            <h5>Networking Works: Leveraging Networks for Growth and Success</h5>

                            </strong>
                  
                  <h4> <i>Kazé, Bangalore</i></h4>
                            <br/><br/>
                    
                          <center>  
         <a href="/SheShines30June2022/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
                 
              
                          </div>
                      </div>
                    </div>
       
              <hr/><hr/>

  
              </div>        
                    
	</div>
	<div class="tab-pane  " id="tabs-3" role="tabpanel"><br/><br/><br/>
 
  <div className="eventlist_listing eventlist_listing_new">
                  
  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>November 10, 2022 (5:00 - 8:00 PM IST)</h3>
                           <br/>
                            <strong>
                            Journey's: Women & Leadership
                            </strong>
                          
                            <h4> <i>The Quorum Club, LowerParel, Mumbai</i></h4>
                            <br/><br/>
                          <center>  
         <a href="/SheShines10Nov2022/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
                        </div>
                      </div>
                    </div> 
                  
  <hr/><hr/>
                  <div className="row">
                      <div className="col-md-12 col-sm-12 col-xs-12">
                      <div className="top_e_border"></div>
                        <div className="list_card">
                          <h3>April 21, 2022 (4:30 PM IST)</h3>
                           <br/>
                            <strong>
                            Networking works
                            </strong>
                          
                            <h4> <i>The Quorum Club, LowerParel, Mumbai</i></h4>
                            <br/><br/>
                          <center>  
         <a href="/SheShinesWithWinPE/"><button style={{backgroundColor:"#BF2026", border:"none", color:"#fff", padding:"5px 20px 5px 20px", fontSize:"20px", marginBottom: "10px"}} class="button"> Event Report</button> </a> </center> 
                          <br/> 
              
                        </div>
                      </div>
                    </div>
                    <hr/><hr/>
                   
                    </div>
 
 
 
 
 </div>
	</div>
 
</div>
        
<br/>    
<br />
</div>
                <TeamModal
                show={isShow}
                onHide={this.togglePopUp}
                activeItem={this.state.activeItem}
              />
      </div></div>
      </ContentPage>
    );
  }
}




WinPEEdge.propTypes = {
  location: PropTypes.object,
};

export default WinPEEdge;
 


// WEBPACK FOOTER //
// ./src/pages/SheShines/index.js